// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3cgKR","label":"Category_label__qK2-i","content":"Category_content__3O_sy","header":"Category_header__xiPY7","location":"Category_location__39XuH"};